<style>
#edition .v-select__slot {
  border: none;
}
#edition .v-select__slot .v-select__selection {
  font-size: 12px;
}
/* select warstwy aktywnej pod przyciskiem tabeli atrybutów  */
#edition > div > div:nth-child(2) > div > div:nth-child(2) > div {
  width: 100% !important;
}
.ribbon-button input {
  font-size: 10px;
}
.v-text-field.v-select .v-select__selection--comma + input {
  max-width: 20px;
}
.v-select.disabled,
.v-select[disabled],
.v-select:disabled {
  pointer-events: none !important;
  color: darkgrey !important;
}

.ribbon-button .v-menu .v-btn {
  margin: 0px;
}

#active-layer--select
  .v-input.disabled
  .v-select__selections
  .v-select__selection {
  color: gray;
}
</style>

<template>
  <vue-custom-scrollbar
    class="v-bar-element"
    v-bind:settings="{suppressScrollY : true}"
    ref="bar-element"
  >
    <div class="group">
      <button
        class="ribbon-button"
        @click="show('legendModal')"
        title="Legenda mapy"
      >
        <span class="icon">
          <v-icon>layers</v-icon>
        </span>
        <span class="caption">WARSTWY</span>
      </button>
    </div>
    <div class="group">
      <div class="container__group--rows">
        <div class="ribbon__row border--bottom">
          <div
            class="ribbon-button ribbon__row--flex"
            @click="akcjaOtworzTabeleDanych"
            :class="{disabled : !currentLayer || !!userLayerState, active : tableDataActive}"
          >
            <span class="icon">
              <v-icon>table_chart</v-icon>
            </span>
            <span class="caption">TABELA ATRYBUTÓW</span>
          </div>
        </div>
        <div
          class="ribbon__row border--bottom"
          id="active-layer--select"
        >
          <div class="ribbon-button ribbon__row--flex">
            <v-select
              style="max-width: 220px;"
              ref="layersSelect"
              placeholder="Aktywna warstwa"
              height="18"
              :items="layersList"
              item-value="key"
              item-text="name"
              :return-object="true"
              no-data-text="Brak warstw"
              v-model="currentLayer"
              :menu-props="{'max-width' : 215}"
              :class="{disabled : edition || editionAnyAction || !!userLayerState || !isSessionEmpty()}"
            >
              <template v-slot:selection="{ item, index }">
                <span style="white-space: nowrap;">{{ item.short_name }}</span>
              </template>
              <template v-slot:item="{ item, index }">
                <span
                  :title="item.name"
                  style="white-space: nowrap;"
                >{{ item.short_name }}</span>
              </template>
            </v-select>
          </div>
        </div>
      </div>
    </div>

    <template v-if="!!currentLayer && currentLayer.type == 'wodkan'">
      <div class="group">
        <button
          class="ribbon-button"
          title="Przełączenie w tryb edycji"
          @click="przelaczenieWTrybEdycji"
          :class="{active : edition}"
        >
          <span class="icon">
            <v-icon>edit</v-icon>
          </span>
          <span class="caption">Tryb Edycji</span>
        </button>
      </div>
      <div class="group">
        <button
          class="ribbon-button"
          title="Edycja atrybutów"
          :class="{disabled : currentFeatures.length == 0}"
          @click="akcjaOtworzAtrybuty"
        >
          <span class="icon">
            <v-icon>local_offer</v-icon>
          </span>
          <span class="caption">ATRYBUTY...</span>
        </button>
      </div>
      <div class="group">
        <div class="container__group--rows">
          <div class="ribbon__row border--bottom">
            <div
              class="ribbon-button ribbon__row--flex"
              :class="{disabled : !drawActive && (!drawEnable || editionAnyAction || !isSessionEmpty()), active : drawActive}"
              @click="akcjaWstawObiekt"
            >
              <span class="icon">
                <v-icon small>save_alt</v-icon>
              </span>
              <button class="caption">Wstaw obiekt</button>
            </div>

            <div
              class="ribbon-button ribbon__row--flex"
              style="padding-right: 0px;"
              :title="dropdownEditButtons[currentEditButton].tooltip"
              :class="{disabled : !modyfiActive && (!modyfiEnable || editionAnyAction || !isSessionEmpty()), active : modyfiActive}"
              @click.self="akcjaEdytujGeometrie"
            >
              <span class="icon">
                <v-icon small>border_color</v-icon>
              </span>
              <button
                class="caption"
                @click.self="akcjaEdytujGeometrie"
              >Edytuj...</button>
              <v-menu
                offset-y
                :disabled="modyfiActive"
              >
                <v-btn
                  slot="activator"
                  flat
                  icon
                  depressed
                  small
                >
                  <v-icon small>arrow_drop_down</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile
                    v-for="(button, key, index) in dropdownEditButtons"
                    :key="`${key}-${index}`"
                    @click="currentEditButton = key"
                    :value="key == currentEditButton"
                    active-class="primary primary--text text--lighten-4"
                  >
                    <v-list-tile-title v-text="button.text"></v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </div>
          </div>
          <div class="ribbon__row border--bottom">
            <div
              class="ribbon-button ribbon__row--flex"
              :class="{disabled : !joinActive && (!joinEnable || editionAnyAction || !isSessionEmpty()), active : joinActive}"
              @click="akcjaZlacz"
            >
              <span class="icon">
                <v-icon small>call_merge</v-icon>
              </span>
              <button class="caption">Złącz</button>
            </div>

            <div
              class="ribbon-button ribbon__row--flex"
              style="padding-right: 0px;"
              :title="dropdownSplitButtons[currentSplitButton].tooltip"
              :class="{disabled : !splitActive && (!splitEnable || editionAnyAction || !isSessionEmpty()), active : splitActive}"
              @click.self="akcjaRozdziel"
            >
              <span class="icon">
                <v-icon small>import_export</v-icon>
              </span>
              <button
                class="caption"
                @click.self="akcjaRozdziel"
              >Rozdziel...</button>
              <v-menu
                offset-y
                :disabled="splitActive"
              >
                <v-btn
                  slot="activator"
                  flat
                  icon
                  depressed
                  small
                >
                  <v-icon small>arrow_drop_down</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile
                    v-for="(button, key, index) in dropdownSplitButtons"
                    :key="`${key}-${index}`"
                    @click="currentSplitButton = key"
                    :value="key == currentSplitButton"
                    active-class="primary primary--text text--lighten-4"
                  >
                    <v-list-tile-title v-text="button.text"></v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </div>

            <div
              class="ribbon-button ribbon__row--flex"
              :class="{disabled : !deleteEnable || editionAnyAction || !isSessionEmpty()}"
              @click="akcjaUsun"
            >
              <span class="icon">
                <v-icon small>delete</v-icon>
              </span>
              <button class="caption">Usuń</button>
            </div>
          </div>
        </div>
      </div>
      <div class="group">
        <div class="container__group--rows">
          <div
            class="ribbon-button ribbon__row"
            :class="{disabled : !edition || !editionAnyAction && isSessionEmpty()}"
            @click="akcjaCofnij"
          >
            <span class="icon">
              <v-icon small>settings_backup_restore</v-icon>
            </span>
            <button class="caption">Cofnij</button>
          </div>

          <div
            class="ribbon-button ribbon__row"
            :class="{disabled : !edition || !editionAnyAction && isSessionEmpty()}"
            @click="akcjaZapisz"
          >
            <span class="icon">
              <v-icon small>save</v-icon>
            </span>
            <button class="caption">Zapisz</button>
          </div>
        </div>
      </div>
      <div class="group">
        <button
          class="ribbon-button"
          title="Kopiuj zaznaczone obiekty"
          @click="akcjaKopiujFeatures"
          :class="{disabled : currentFeatures.length < 1 }"
        >
          <span class="icon">
            <v-icon>cloud_upload</v-icon>
          </span>
          <span class="caption">KOPIUJ</span>
        </button>
      </div>
    </template>
    <template v-if="!!currentLayer && currentLayer.type == 'user'">
      <div class="group">
        <div class="container__group--rows">
          <div class="ribbon__row border--bottom">
            <div
              class="ribbon-button ribbon__row--flex"
              :class="{/*disabled : (!!userLayerState && userLayerState != 'add_Point'),*/ disabled : geometry_type != 'point', active : userLayerState == 'add_Point'}"
              @click="changeEditModeUserLayer('add', 'Point')"
              title="Dodaj nowy punkt"
            >
              <span class="icon">
                <v-icon small>save_alt</v-icon>
              </span>
              <button class="caption">Punkt</button>
            </div>

            <div
              class="ribbon-button ribbon__row--flex"
              :class="{/*disabled : (!!userLayerState && userLayerState != 'add_LineString'),*/ disabled : geometry_type != 'linestring', active : userLayerState == 'add_LineString'}"
              @click="changeEditModeUserLayer('add', 'LineString')"
              title="Dodaj nową linie"
            >
              <span class="icon">
                <v-icon small>save_alt</v-icon>
              </span>
              <button class="caption">Linie</button>
            </div>

            <div
              class="ribbon-button ribbon__row--flex"
              :class="{/*disabled : (!!userLayerState && userLayerState != 'add_Polygon'),*/ disabled : geometry_type != 'polygon', active : userLayerState == 'add_Polygon'}"
              @click="changeEditModeUserLayer('add', 'Polygon')"
              title="Dodaj nowy wielokąt"
            >
              <span class="icon">
                <v-icon small>save_alt</v-icon>
              </span>
              <button class="caption">Wielokąt</button>
            </div>
          </div>
          <div class="ribbon__row border--bottom">
            <div
              class="ribbon-button ribbon__row--flex"
              :class="{/*disabled : (!!userLayerState && userLayerState != 'edit'),*/ active : userLayerState == 'edit'}"
              @click="changeEditModeUserLayer('edit')"
              title="Edytuj elementy"
            >
              <span class="icon">
                <v-icon small>edit</v-icon>
              </span>
              <button class="caption">Edytuj</button>
            </div>

            <div
              class="ribbon-button ribbon__row--flex"
              :class="{/*disabled : (!!userLayerState && userLayerState != 'delete'),*/ active : userLayerState == 'delete'}"
              @click="changeEditModeUserLayer('delete')"
              title="Usuń element"
            >
              <span class="icon">
                <v-icon small>delete</v-icon>
              </span>
              <button class="caption">Usuń</button>
            </div>

            <div
              class="ribbon-button ribbon__row--flex"
              :class="{disabled : !userLayerState, active : userLayerState == 'save'}"
              @click="changeEditModeUserLayer('save')"
            >
              <span class="icon">
                <v-icon small>save</v-icon>
              </span>
              <button class="caption">Zapisz</button>
            </div>

            <div
              class="ribbon-button ribbon__row--flex"
              :class="{disabled : !userLayerState, active : userLayerState == 'cancel'}"
              @click="changeEditModeUserLayer('cancel')"
            >
              <span class="icon">
                <v-icon small>settings_backup_restore</v-icon>
              </span>
              <button class="caption">Anuluj</button>
            </div>
          </div>
        </div>
      </div>
      <div class="group">
        <div class="container__group--rows">
          <div class="ribbon__row border--bottom">

            <div
              class="ribbon-button ribbon__row--flex"
              title="Kopiuj zaznaczone obiekty"
              @click="akcjaKopiujFeatures"
              :class="{disabled : currentFeatures.length < 1 }"
            >
              <span class="icon">
                <v-icon small>cloud_upload</v-icon>
              </span>
              <button class="caption">KOPIUJ</button>
            </div>

          </div>
          <div class="ribbon__row border--bottom">

            <div
              class="ribbon-button ribbon__row--flex"
              title="Wklej skopiowane elementy"
              @click="akcjaWklejFeatures"
              :class="{disabled : copyFeatures.length < 1 }"
            >
              <span class="icon">
                <v-icon small>cloud_download</v-icon>
              </span>
              <button class="caption">WKLEJ</button>
            </div>

          </div>
        </div>
      </div>
    </template>
    <template v-if="!!currentLayer && currentLayer.type == 'temp'">
      <div class="group">
        <div class="container__group--rows">
          <div class="ribbon__row border--bottom">
            <div
              class="ribbon-button ribbon__row--flex"
              :class="{ disabled : geometry_type != 'point' && geometry_type != 'any', active : tempLayerState == 'add_Point'}"
              @click="changeEditModeTempLayer('add', 'Point')"
              title="Dodaj nowy punkt"
            >
              <span class="icon">
                <v-icon small>save_alt</v-icon>
              </span>
              <button class="caption">Punkt</button>
            </div>

            <div
              class="ribbon-button ribbon__row--flex"
              :class="{ disabled : geometry_type != 'linestring' && geometry_type != 'any', active : tempLayerState == 'add_LineString'}"
              @click="changeEditModeTempLayer('add', 'LineString')"
              title="Dodaj nową linie"
            >
              <span class="icon">
                <v-icon small>save_alt</v-icon>
              </span>
              <button class="caption">Linia</button>
            </div>

            <div
              class="ribbon-button ribbon__row--flex"
              :class="{ disabled : geometry_type != 'polygon' && geometry_type != 'any', active : tempLayerState == 'add_Polygon'}"
              @click="changeEditModeTempLayer('add', 'Polygon')"
              title="Dodaj nowy wielokąt"
            >
              <span class="icon">
                <v-icon small>save_alt</v-icon>
              </span>
              <button class="caption">Wielokąt</button>
            </div>
          </div>
          <div class="ribbon__row border--bottom">
            <div
              class="ribbon-button ribbon__row--flex"
              :class="{ active : tempLayerState == 'edit'}"
              @click="changeEditModeTempLayer('edit')"
              title="Edytuj elementy"
            >
              <span class="icon">
                <v-icon small>edit</v-icon>
              </span>
              <button class="caption">Edytuj</button>
            </div>

            <div
              class="ribbon-button ribbon__row--flex"
              :class="{ active : tempLayerState == 'delete'}"
              @click="changeEditModeTempLayer('delete')"
              title="Usuń element"
            >
              <span class="icon">
                <v-icon small>delete</v-icon>
              </span>
              <button class="caption">Usuń</button>
            </div>

          </div>
        </div>
      </div>
      <div class="group">
        <div class="container__group--rows">
          <div class="ribbon__row border--bottom">

            <div
              class="ribbon-button ribbon__row--flex"
              title="Kopiuj zaznaczone obiekty"
              @click="akcjaKopiujFeatures"
              :class="{disabled : currentFeatures.length < 1 }"
            >
              <span class="icon">
                <v-icon small>cloud_upload</v-icon>
              </span>
              <button class="caption">KOPIUJ</button>
            </div>

          </div>
          <div class="ribbon__row border--bottom">

            <div
              class="ribbon-button ribbon__row--flex"
              title="Wklej skopiowane elementy"
              @click="akcjaWklejFeatures"
              :class="{disabled : copyFeatures.length < 1 }"
            >
              <span class="icon">
                <v-icon small>cloud_download</v-icon>
              </span>
              <button class="caption">WKLEJ</button>
            </div>

          </div>
        </div>
      </div>
    </template>

    <div class="group">
      <button
        class="ribbon-button"
        title="Ustawienia przyciągania"
        :class="{disabled : edition || !!userLayerState}"
        @click="akcjaOtworzUstawienia"
      >
        <span class="icon">
          <v-icon>settings</v-icon>
        </span>
        <span class="caption">USTAWIENIA...</span>
      </button>
    </div>
    <div class="group">
      <div class="container__group--rows">
        <div class="ribbon__row border--bottom">

          <div
            class="ribbon-button ribbon__row--flex"
            title="Stwórz nową warstwę użytkownika"
            @click="createNewUserLayer"
            :class="{disabled : edition && currentLayer.type != 'user'}"
          >
            <span class="icon">
              <v-icon small>map</v-icon>
            </span>
            <button class="caption">STWÓRZ</button>
          </div>

          <div
            class="ribbon-button ribbon__row--flex"
            title="Edycja warstwy użytkownika"
            @click="editUserLayer"
            v-if="currentLayer && currentLayer.type == 'user'"
          >
            <span class="icon">
              <v-icon small>edit</v-icon>
            </span>
            <button class="caption">EDYCJA</button>
          </div>

          <div
            class="ribbon-button ribbon__row--flex"
            title="Usuń warstwę użytkownika"
            @click="removeUserLayer(currentLayer)"
            v-if="currentLayer && currentLayer.type == 'user'"
          >
            <span class="icon">
              <v-icon small>delete</v-icon>
            </span>
            <button class="caption">USUŃ</button>
          </div>

          <div
            class="ribbon-button ribbon__row--flex"
            title="Usuń warstwę tymczasową"
            @click="removeTempLayer(currentLayer)"
            v-if="currentLayer && currentLayer.type == 'temp'"
          >
            <span class="icon">
              <v-icon small>delete</v-icon>
            </span>
            <button class="caption">USUŃ</button>
          </div>

        </div>
        <div class="ribbon__row border--bottom">

          <div
            class="ribbon-button ribbon__row--flex"
            title="Importowanie różnych danych"
            @click="akcjaOtworzOknoImportu"
            :class="{disabled : edition && currentLayer.type != 'user'}"
          >
            <span class="icon">
              <v-icon small>arrow_downward</v-icon>
            </span>
            <button class="caption">IMPORT</button>
          </div>

          <div
            class="ribbon-button ribbon__row--flex"
            title="Eksportuj dane aktualnej warstwy"
            @click="akcjaEksportuj"
            :class="{disabled : !currentLayer}"
          >
            <span class="icon">
              <v-icon small>arrow_upward</v-icon>
            </span>
            <button
              class="caption"
              :class="{disabled : !currentLayer}"
            >EKSPORT</button>
          </div>

          <div
            class="ribbon-button ribbon__row--flex"
            title="Złaczenia warstw"
            @click="show('layersJoinModal')"
            :class="{disabled : edition && currentLayer.type != 'user'}"
          >
            <span class="icon">
              <v-icon small>vertical_align_center</v-icon>
            </span>
            <button class="caption">ZŁĄCZENIA</button>
          </div>

        </div>
      </div>
    </div>

    <div
      class="group"
      style="max-width: 160px;"
    >
      <CommonComp />
    </div>
    <div
      class="more-hidden"
      id="showMore"
    >
      <a href="#">
        <span class="fa fa-ellipsis-h"></span>
      </a>
      <ul class="hidden-menu"></ul>
    </div>
  </vue-custom-scrollbar>
</template>

<script>
import CommonComp from "../../shared/CommonComp";
import vueCustomScrollbar from 'vue-custom-scrollbar';
import io from "socket.io-client";

import snap_options from "../../../utils/snap_options.json";

import OL3Parser from "jsts/org/locationtech/jts/io/OL3Parser";
import {Coordinate} from "jsts/org/locationtech/jts/geom";
import LineMerger from "jsts/org/locationtech/jts/operation/linemerge/LineMerger"; //SRC tylko w wersji deveeloperskiej '/src'

import ShpGenerate from "../../../utils/ShpGenerate.js";

import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import map from "lodash/map";
import filter from "lodash/filter";
import includes from "lodash/includes";
import isEmpty from "lodash/isEmpty";
import some from "lodash/some";
import isArray from "lodash/isArray";
import each from "lodash/each";
import sortBy from "lodash/sortBy";
import find from "lodash/find";
import flatten from "lodash/flatten";
import keyBy from "lodash/keyBy";
import mapValues from "lodash/mapValues";
import clone from "lodash/clone";
import findKey from "lodash/findKey";
import omitBy from "lodash/omitBy";
import get from "lodash/get";
import extend from "lodash/extend";
import debounce from "lodash/debounce";
import groupBy from "lodash/groupBy";
mixin(_, {
  map,
  filter,
  includes,
  isEmpty,
  some,
  isArray,
  each,
  chain,
  sortBy,
  find,
  keyBy,
  mapValues,
  clone,
  flatten,
  findKey,
  omitBy,
  extend,
  debounce,
  groupBy,
  get: get,
  eachSequence(elements, callback) {
    for(let i = 0; i < elements.length - 1; i++) {
      callback(elements[i], elements[i + 1]);
    }
  }
});
_.value = value;
_.prototype.value = value;

import Collection from "ol/Collection";
import {Draw, Modify, Snap, DragBox} from "ol/interaction";
import Split from "ol-ext/interaction/Split";
import {Vector as VectorSource, Cluster} from "ol/source";
import {WKT, GeoJSON} from "ol/format";
import {createDefaultStyle} from "ol/style/Style";
import {shiftKeyOnly, singleClick} from "ol/events/condition";
import Feature from "ol/Feature";
import {
  buffer as bufferExtent,
  createOrUpdateFromCoordinate
} from "ol/extent";
import {getArea, getLength} from "ol/sphere.js";
import {
  Group as LayerGroup,
  Vector as VectorLayer,
  Tile as TileLayer
} from "ol/layer";

const formatWKT = new WKT();
let formatGeoJSON;
const ol_parser = new OL3Parser();
//window.formatWKT = formatWKT;

import {
  LineString,
  Polygon,
  MultiPoint,
  MultiPolygon,
  MultiLineString,
  Point
} from "ol/geom";
import LinearRing from "ol/geom/LinearRing";
import GeometryCollection from "ol/geom/GeometryCollection";
ol_parser.inject(
  Point,
  LineString,
  LinearRing,
  Polygon,
  MultiPoint,
  MultiLineString,
  MultiPolygon,
  GeometryCollection
);

const equalsCoordinateTolerance = 0.5;

export default {
  components: {
    CommonComp,
    vueCustomScrollbar
  },
  data: () => ({
    currentLayer: undefined,

    edition: false,

    geometry_type: false,
    splitActive: false,
    joinActive: false,
    drawActive: false,
    modyfiActive: false,
    tableDataActive: false,

    currentEditButton: "modyfi",
    currentSplitButton: "split_point",

    currentFeatures: [],
    session: {},
    nextID: -1,

    //copy i past
    copyFeatures: [],

    userLayerState: false, //'edit', 'add_point', 'add_line', 'add_polygon', 'delete'
    tempLayerState: false, //'edit', 'add_point', 'add_line', 'add_polygon', 'delete'
  }),
  computed: {
    drawEnable() {
      return (
        this.edition &&
        this.currentLayer &&
        this.geometry_type !== "none" &&
        this.currentFeatures.length === 0 &&
        this.isSessionEmpty()
      );
    },
    modyfiEnable() {
      return (
        this.edition &&
        this.currentLayer &&
        this.geometry_type !== "none" &&
        this.currentFeatures.length === 1 &&
        this.isSessionEmpty()
      );
    },
    deleteEnable() {
      return (
        this.edition &&
        this.currentLayer &&
        this.currentFeatures.length > 0 &&
        this.isSessionEmpty()
      );
    },
    splitEnable() {
      return (
        this.edition &&
        this.currentLayer &&
        this.geometry_type === "linestring" &&
        this.currentFeatures.length === 1 &&
        this.isSessionEmpty()
      );
    },
    joinEnable() {
      return (
        this.edition &&
        this.currentLayer &&
        this.geometry_type === "linestring" &&
        this.currentFeatures.length === 1 &&
        this.isSessionEmpty()
      );
    },
    editionAnyAction() {
      return (
        this.drawActive ||
        this.modyfiActive ||
        this.splitActive ||
        this.joinActive
      );
    },

    activeModals() {
      return this.$store.getters.getModalsList;
    },
    map() {
      return this.$store.getters.getMap;
    },
    layers() {
      const self = this;
      const wodkan_layers = _.chain(
        self.map
          .getLayers()
          .item(2) //warstwy wodkan
          .getLayers()
          .getArray()
      )
        .filter(layer =>
          _.includes(["water", "sewer"], layer.get("layer_type"))
        )
        .map(layer => ({
          name: layer.get("full_name"),
          short_name:
            layer.get("full_name").length > 24
              ? `${layer.get("full_name").slice(0, 24)}...`
              : layer.get("full_name"),
          key: layer.get("full_type"),
          save_key: layer.get("type"),
          get save_key_suffix() {
            return layer.get("full_type").split('@')[1];
          },
          type: "wodkan",
          fields: layer.get('fields'),
          instance: self.$root.createProxy(layer)
        }))
        .value();

      const user_layers = _.chain(
        self.map
          .getLayers()
          .item(1) //warstwy różne
          .getLayers()
          .item(0) //warstwy użtkownika
          .getLayers()
          .getArray()
      )
        .filter(layer => layer instanceof VectorLayer)
        .map(layer => ({
          name: `WU: ${layer.get("name")}`,
          table: layer.get("table"),
          short_name:
            layer.get("name").length > 21
              ? `WU:  ${layer.get("name").slice(0, 21)}...`
              : `WU: ${layer.get("name")}`,
          key: layer.get("full_type"),
          type: "user",
          fields: layer.get('fields'),
          instance: self.$root.createProxy(layer)
        }))
        .value();

      const temp_layers = _.chain(
        self.map
          .getLayers()
          .item(1) //warstwy różne
          .getLayers()
          .item(1) //warstwy tymczasowe
          .getLayers()
          .getArray()
      )
        .filter(layer => layer instanceof VectorLayer)
        .map(layer => ({
          name: `T: ${layer.get("name")}`,
          short_name:
            layer.get("name").length > 22
              ? `T:  ${layer.get("name").slice(0, 22)}...`
              : `T: ${layer.get("name")}`,
          key: layer.get("full_type"),
          type: "temp",
          fields: layer.get('fields'),
          instance: self.$root.createProxy(layer)
        }))
        .value();

      return _.keyBy([...wodkan_layers, ...user_layers, ...temp_layers], "key");
    },
    layersList() {
      return Object.values(this.layers)
              .filter(layer => layer.type !== 'wodkan' 
                || (this.$can('read', layer.save_key) || this.$can('edit', layer.save_key)));
    },
    layersInstance() {
      return this.$store.getters.getLayersInstance;
    },
    srid() {
      return this.$store.getters.getSrid;
    },

    snapTolerance() {
      return this.$store.getters.getSnapTolerance;
    },
    snapLayers() {
      return this.$store.getters.getSnapLayers;
    },

    dropdownEditButtons() {
      switch(this.toModeDraw(this.geometry_type)) {
        case "LineString":
        case "Polygon":
          return {
            add_node: {
              text: "Dodaj wierzchołek",
              tooltip: "Dodaj wierzchołek"
            },
            remove_node: {
              text: "Usuń wierzchołek",
              tooltip: "Usuń wierzchołek"
            },
            modyfi: {
              text: "Modyfikuj",
              tooltip: "Modyfikuj geometrie"
            }
          };
        default:
          this.currentEditButton = "modyfi";
          return {
            modyfi: {
              text: "Modyfikuj",
              tooltip: "Modyfikuj geometrie"
            }
          };
      }
    },
    dropdownSplitButtons() {
      return {
        split_middle: {
          text: "Rozdziel w połowie",
          tooltip: "Rozdziel w połowie"
        },
        split_distance: {
          text: "Rozdziel w odległości",
          tooltip: "Rozdziel w odległości"
        },
        split_point: {
          text: "Rozdziel w punkcie",
          tooltip: "Rozdziel w punkcie"
        }
      };
    },

    currentSelectedFeatures() {
      return this.$store.getters.getCurrentSelectedFeatures;
    },

    modificationLayer() {
      return this.map
        .getLayers()
        .item(3)
        .getLayers()
        .item(2);
    },
    allowsSelectLayer() {
      return this.map
        .getLayers()
        .item(3)
        .getLayers()
        .item(1);
    },
    selectedLayer() {
      return this.map
        .getLayers()
        .item(3)
        .getLayers()
        .item(0);
    },

    userLayers() {
      return this.$store.getters.getUserLayers;
    },
    tempLayers() {
      return this.$store.getters.getTempLayers;
    },
  },
  watch: {
    edition(_new) {
      const self = this;

      if(_new) {
        self.socket = io.connect(`${self.currentApiURL}`, {
          path: "/socket.io/websocket",
          transports: ["websocket"],
          query: {
            token: self.currentToken,
            website: true
          },
          autoConnect: false,
          reconnection: !true
        });
        self.configureSocket();
      } else {
        if(self.socket != null) {
          self.socket.disconnect();
        }

        self.drawActive = false;
        self.modyfiActive = false;
        self.splitActive = false;
        self.joinActive = false;
      }
    },
    currentLayer(_new, _old) {
      this.snapFeatures.clear();
      if(_new) {
        const layer = _new.instance.__value;

        if(_old) {
          if(_old.type === "wodkan") {
          } else if(_old.type === "user") {
            this.clearULCollections(_old.instance.__value, true);
            this.userLayerState = false;
          }
        }

        this.snapFeatures.extend(this.getSource(layer).getFeatures());
        this.snapFeatures.extend(this.getSnapLayersFeatures());
        this.snapFeatures.extend(this.getSnapLayersUserFeatures());

        if(_new.type === "wodkan") {
          this.geometry_type = layer.get("geometry_type");
          this._computedWatchers.dropdownEditButtons.update();
          if(this.edition) {
            this.$root.$emit("toggleLayer", _new.key, true, "data");
            if(layer.selected !== true) {
              layer.selected = true;
              layer.changed();
            }
          } else {
            if(layer.selected !== false) {
              layer.selected = false;
              layer.changed();
            }
          }
        } else if(_new.type === "user") {
          this.geometry_type = layer.get("geometry_type");
          this.$root.$emit("toggleLayer", _new.key, true, "user");
        } else if(_new.type === "temp") {
          this.geometry_type = layer.get("geometry_type");
          this.$root.$emit("toggleLayer", _new.key, true, "temp");
        }

        this.$store.commit("setCurrentEditedLayer", _new.key);
        this.$root.$emit("clearSelectionFeatures");
        this.$root.$emit("changeAttributeTableData", layer);
      }
      if(_old) {
        const layer = _old.instance.__value;
        if(layer.selected !== false) {
          layer.selected = false;
          layer.changed();
        }

        if(_old && _old.type === "user") {
          this.changeEditModeUserLayer("cancel");
        } else if(_old && _old.type === "temp") {
          if(this.tl_last_interaction) {
            this.tl_last_interaction.end();
            this.tl_last_interaction = undefined;
          }
        }
      }
    },

    drawActive(_new) {
      const drawInteraction = this.interactions.draw[
        this.toModeDraw(this.geometry_type)
      ];
      drawInteraction.abortDrawing();
      drawInteraction.setActive(_new);
      this._computedWatchers.drawEnable.update();
      this._computedWatchers.editionAnyAction.update();

      this.$emit("changeModeEnd", "draw", _new);
    },
    modyfiActive(_new) {
      let feature;
      if(_new) {
        feature = this.currentFeatures[0].__value;
        feature.orginalGeometry = formatWKT.writeGeometryText(
          feature.getGeometry()
        );
        this.modificationLayer.getSource().addFeature(feature);

        const coordinates = feature.getGeometry().getCoordinates();

        let points = [];
        switch(this.toModeDraw(this.geometry_type)) {
          case "LineString":
            points = _.map(
              coordinates,
              (coord, index) =>
                new Feature({
                  geometry: new Point(coord),
                  index,
                  __hide: true
                })
            );
            break;
          case "Polygon":
            points = _.map(
              coordinates[0],
              (coord, index) =>
                new Feature({
                  geometry: new Point(coord),
                  index,
                  __hide: true
                })
            );
            break;
        }

        this.modificationLayer.getSource().addFeatures(points);
      } else {
        if("modificated" in this.session) {
          feature = this.session.modificated.feature.__value;
          delete this.session.modificated.feature.__value.orginalGeometry;
        } else {
          this.modificationLayer.getSource().clear(true);
        }
      }
      this.interactions.modyfi.setActive(_new);
      this._computedWatchers.modyfiEnable.update();
      this._computedWatchers.editionAnyAction.update();

      this.$emit("changeModeEnd", "modyfi", _new, feature);
    },
    splitActive(_new) {
      let feature;
      switch(this.currentSplitButton) {
        case "split_point": {
          if(_new) {
            this.splitFeatures.extend(
              _.map(this.currentFeatures, proxy => proxy.__value)
            );
          } else {
            feature = _.get(
              this.session,
              "splitted.original",
              this.$root.createProxy(this.splitFeatures.item(0))
            ).__value;
          }
          this.interactions.split.setActive(_new);
          break;
        }
        case "split_middle": {
          if(_new) {
            this.splitMiddleExecut(this.currentFeatures[0].__value);
          } else {
            feature = this.session.splitted.original.__value;
          }
          break;
        }
        case "split_distance": {
          if(_new) {
            this.dialogSplitDistanceAction(this.currentFeatures[0].__value);
          } else {
            feature = _.get(
              this.session,
              "splitted.original",
              this.currentFeatures[0]
            ).__value;
          }
          break;
        }
      }

      if(!_new) {
        this.splitFeatures.clear();
      }

      this._computedWatchers.splitEnable.update();
      this._computedWatchers.editionAnyAction.update();

      this.$emit("changeModeEnd", "split", _new, feature);
    },
    joinActive(_new) {
      let feature;
      const source = this.allowsSelectLayer.getSource();
      if(_new) {
        const closestFeatures = this.getClosestFeatures(
          this.getSource(this.currentLayer.instance),
          this.currentFeatures[0].__value,
          1
        );
        source.addFeatures(closestFeatures.all);
      } else {
        if("joined" in this.session) {
          feature = this.session.joined.originals[0].__value;
        } else {
          feature = this.currentFeatures[0].__value;
        }
        source.clear(true);
      }
      this._computedWatchers.joinEnable.update();
      this._computedWatchers.editionAnyAction.update();

      this.$emit("changeModeEnd", "join", _new, feature);
    },

    currentEditButton() {
      this.$nextTick(() => {
        this.modyfiActive = !this.modyfiActive;
      });
    },
    currentSplitButton() {
      this.$nextTick(() => {
        this.splitActive = !this.splitActive;
      });
    },
    editionAnyAction(_new) {
      if(_new) {
        this.offSelectionTools();
      }
    },

    currentSelectedFeatures(_new) {
      this.discardChanges_();

      //zaznaczono kilka
      if (this.currentLayer && this.currentLayer.instance.getSource() instanceof Cluster) {
        _new = _(_new).map((f) => f.get('features')).flatten().map((f) => this.$root.createProxy(f)).value();
      }
      this.currentFeatures = _new;

      this._computedWatchers.deleteEnable.update();
      this._computedWatchers.splitEnable.update();
      this._computedWatchers.joinEnable.update();
      this._computedWatchers.drawEnable.update();
      this._computedWatchers.modyfiEnable.update();

      this._computedWatchers.editionAnyAction.update();
      this.modificationLayer.getSource().clear();
    },

    snapTolerance(_new) {
      if(this.snapInteraction) {
        this.map.removeInteraction(this.snapInteraction);
      }
      this.createSnapInteraction();
    },
    snapLayers() {
      this.snapFeatures.clear();
      if(this.currentLayer) {
        const layer = this.currentLayer.instance.__value;
        this.snapFeatures.extend(this.getSource(layer).getFeatures());
        this.snapFeatures.extend(this.getSnapLayersFeatures());
        this.snapFeatures.extend(this.getSnapLayersUserFeatures());
      }
    },

    userLayers() {
      this.currentLayer = undefined;
      setTimeout(() => {
        this.updateLayers();
      }, 5000);
    },
    tempLayers() {
      this.currentLayer = undefined;
      setTimeout(() => {
        this.updateLayers();
      }, 5000);
    },
  },
  methods: {
    updateLayers() {
      this._computedWatchers.layers.update();
      this._computedWatchers.layersList.update();
      this.$forceUpdate();
    },
    setActiveLayer(key) {
      const unwatch = this.$watch('layers', (_new) => {
        if(key in _new) {
          unwatch();
          setTimeout(() => {
            this.currentLayer = this.layers[key];
          }, 500);
        }
      });
    },
    editUserLayer() {
      const self = this;
      this.$root.$emit("editUserLayer", self.currentLayer);
      this.show("NewUserLayer");
    },
    show(title) {
      if(this.activeModals.indexOf(title) === -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    clone(data) {
      return JSON.parse(JSON.stringify(data));
    },
    addEvent(elm, evType, fn, useCapture) {
      if(elm.addEventListener) {
        elm.addEventListener(evType, fn, useCapture);
      } else if(elm.attachEvent) {
        elm.attachEvent("on" + evType, fn);
      } else {
        elm["on" + evType] = fn;
      }
    },
    toModeDraw(geometry_type) {
      switch(geometry_type) {
        case "point":
          return "Point";
        case "linestring":
          return "LineString";
        case "polygon":
          return "Polygon";
      }
    },
    getBaseProps() {
      return (
        _(this.currentLayer.instance.get("fields"))
          .map(field => {
            if("dictionary" in field) {
              return {
                name: field.name,
                value: _.findKey(
                  field.dictionary,
                  (v, k) => v.value === field.default
                )
              };
            } else if("model_roughness" === field.name) {
              return {
                name: field.name,
                value: JSON.parse(field.default || "{}").default || null
              };
            } else {
              return {
                name: field.name,
                value: field.default || null
              };
            }
          })
          //.filter((field) => field.value)
          .keyBy("name")
          .mapValues("value")
          .value()
      );
    },
    getSource(layer) {
      const source = layer.getSource();
      return source instanceof Cluster ? source.getSource() : source;
    },
    cloneProps(original, feature) {
      _.each(original.getProperties(), (value, key) => {
        if(key !== "geometry") {
          feature.set(key, value);
        }
      });
    },
    getCoordinates(feature) {
      switch(feature.getGeometry().getType()) {
        case "Point":
        case "LineString":
          return feature.getGeometry().getCoordinates();
        case "Polygon":
          return feature.getGeometry().getCoordinates()[0];
      }
    },
    getPointCoordinate(geometry) {
      if(geometry instanceof Point) {
        return ol_parser.read(geometry).getCoordinate();
      } else {
        return this.getPointCoordinate(new Point(geometry));
      }
    },
    offSelectionTools() {
      this.$root.$emit("identificationFeature", "cancel");
      this.$root.$emit("identificationFeature", "stop");
    },
    getIntersectionPoints(feature, layer, _new = true) {
      const source = this.getSource(layer);
      const coords = this.getCoordinates(feature);

      const result = [coords[0], coords[coords.length - 1]]; //pierwszy i ostatni zawsze
      _.each(coords.slice(1, -1), coord => {
        const extent = [coord[0], coord[1], coord[0], coord[1]]; //jakby co mozna dodać lekki bufor
        const features = _.filter(source.getFeaturesInExtent(extent),
          (f) => f.getId() !== feature.getId() && f.getGeometry().intersectsExtent(extent));
        if(features.length > 0) {
          result.push(coord);
        }
      });

      return _.map(result, coord => new Point(coord));
    },
    roundNumber(value, places) {
      return +value.toFixed(places);
    },
    roundCoords(coords, places) {
      if(_.isArray(coords)) {
        _.each(coords, coord => {
          this.roundCoords(coord, places);
        });
      } else {
        coords.x = this.roundNumber(coords.x, places);
        coords.y = this.roundNumber(coords.y, places);
      }
    },

    //<editor-fold defaultstate="collapsed" desc="socket">
    configureSocket() {
      const self = this;
      self.socket.on("connect", () => {
        self.$root.$emit("showSnackbar", "success", "Połączono pomyślnie");
        if(self.currentLayer) {
          self.$root.$emit("toggleLayer", self.currentLayer.key, true);
          setTimeout(() => self.$root.$emit("refreshAttributeTableData"), 500);
        } else {
          self.currentLayer &&
            self.currentLayer.instance.__value.forceRefresh();
        }
        self.$store.commit("setEditionOn", true);
        self.$store.commit("setSocket", self.$root.createProxy(self.socket));
      });
      self.socket.on("disconnect", () => {
        if(self.edition) {
          self.edition = false;
        }
        self.$root.$emit("showSnackbar", "success", "Rozłączono pomyślnie");
        self.$store.commit("setEditionOn", false);
        self.socket = null;
        self.$store.commit("setSocket", null);
      });
      self.socket.on("connect_error", error => {
        self.$root.$emit("showSnackbar", "error", "Błąd połączenia");
        self.edition = false;
      });
      self.socket.on("connect_timeout", timeout => {
        self.$root.$emit(
          "showSnackbar",
          "error",
          "Upłynął czas próby połaczenia"
        );
        self.edition = false;
      });

      self.socket.on("ping", msg => {
        self.socket.emit("pong");
      });
      self.socket.on("pong", msg => {});

      self.socket.on("error", data => {
        const message = data.error;
        self.$root.$emit("showSnackbar", "error", `Bład z serwera, ${message}`);
      });
      self.socket.on("uncaught_error", data => {
        const message = data.error;
        self.$root.$emit("showSnackbar", "error", `Bład z serwera, ${message}`);
      });

      self.socket.on("data_changed", data => {
        /*
           {
           'meta' : {
           'operation' : operation,
           'featureId' : featureId,
           'username' : user.name,
           'session' : session
           },
           'data' : data
           }
           */
        self.odswiezWidok(data.data);
        this.$root.$emit("showSnackbar", "success", `Zapisano obiekt`);
      });
      self.socketOn("data", data => {});

      /*self.socketOn('update/comments', (data) => {
        });
        self.socketOn('update/attachments', (data) => {
        });
        self.socketOn('update/inventory_ids', (data) => {
        });
 
        self.socketOn('session_created', (data) => {
        });
        self.socketOn('session_deleted', (data) => {
        });
 
        self.socketOn('history', (data) => {
        });*/

      self.socket.connect();
      //console.log(self.socket);
    },
    socketOn(endpoint, callback) {
      this.socket.on(endpoint, data => {
        this.$root.$emit("showSnackbar", "yellow", `socket ${endpoint}`);
        callback(data);
      });
    },
    socketEmit(endpoint, data) {
      return new Promise(resolve => {
        if(this.socket == null || this.socket.disconnected) {
          reject();
          return;
        }

        resolve();
        this.socket.emit(endpoint, data);
      });
    },
    //</editor-fold>

    //<editor-fold defaultstate="collapsed" desc="snap">
    getSnapLayersFeatures() {
      const self = this;
      if(!(self.currentLayer.key in snap_options)) {
        return [];
      }

      return _(snap_options[self.currentLayer.key])
        .filter(key => key in self.layersInstance)
        .map(key => self.layersInstance[key])
        .filter(layer => layer.getVisible())
        .map(layer => self.getSource(layer).getFeatures())
        .flatten()
        .value();
    },
    getSnapLayersUserFeatures() {
      const self = this;

      return _(self.snapLayers)
        .map((layers, type) =>
          _(layers)
            .omitBy(bool => !bool)
            .map((bool, key) => self.layersInstance[key])
            .value()
        )
        .flatten()
        .filter(layer => layer.getVisible())
        .map(layer => self.getSource(layer).getFeatures())
        .flatten()
        .value();

      return [];
    },
    //</editor-fold>

    //<editor-fold defaultstate="collapsed" desc="session">
    clearSession() {
      this.session = {};
    },
    discardChanges_() {
      const self = this;

      self.drawActive = false;
      self.modyfiActive = false;
      self.splitActive = false;
      self.joinActive = false;

      self.allowsSelectLayer.getSource().clear();

      if("deleted" in self.session) {
        //usunięte
        const features = _.map(self.session.deleted, proxy => proxy.__value);
        _.each(features, feature => {
          self.getSource(self.currentLayer.instance).addFeature(feature);
        });
      } else if("draw" in self.session) {
        //nowo narysowane
        const feature = self.session.draw.__value;
        self.modificationLayer.getSource().removeFeature(feature);
      } else if("modificated" in self.session) {
        //nowo zmodyfikowane
        const modificated = self.session.modificated;
        const feature = modificated.feature.__value;
        self.modificationLayer.getSource().removeFeature(feature);
        feature.setGeometry(
          formatWKT.readGeometryFromText(modificated.geometry)
        );
        feature.setProperties(modificated.properties, true);
      } else if("joined" in self.session) {
        //nowo złaczone
        const featuresOriginals = _.map(
          self.session.joined.originals,
          proxy => proxy.__value
        );
        const featureResult = self.session.joined.result.__value;

        self.modificationLayer.getSource().removeFeature(featureResult);
        _.each(featuresOriginals, feature => {
          self.getSource(self.currentLayer.instance).addFeature(feature);
        });
      } else if("splitted" in self.session) {
        //nowo podzielone
        const featureOriginal = self.session.splitted.original.__value;
        const featuresResult = _.map(
          self.session.splitted.results,
          proxy => proxy.__value
        );

        _.each(featuresResult, feature => {
          self.modificationLayer.getSource().removeFeature(feature);
        });
        self.getSource(self.currentLayer.instance).addFeature(featureOriginal);
      }

      self.clearSession();
      self.allowsSelectLayer.getSource().clear();
    },
    discardChanges() {
      this.discardChanges_();
      this.$root.$emit("clearSelectionFeatures");
    },
    getFlags(feature) {
      if(!("flags" in feature)) {
        feature.flags = {};
      }
      return feature.flags;
    },
    isSessionEmpty() {
      return _.isEmpty(this.session);
    },
    //</editor-fold>

    //<editor-fold defaultstate="collapsed" desc="interactions">
    createDrawInteraction(geometry_type) {
      const self = this;

      let ignore = false;
      const features = new Collection();

      const draw = new Draw({
        features: features,
        type: geometry_type,
        snapTolerance: this.snapTolerance
      });
      draw.setActive(false);

      const modify = new Modify({
        features: features,
        pixelTolerance: this.snapTolerance,
        deleteCondition(event) {
          return shiftKeyOnly(event) && singleClick(event);
        }
      });
      modify.setActive(false);

      self.addEvent(
        document,
        "keyup",
        e => {
          e = e || window.event;

          if(!draw.getActive()) {
            return;
          }

          if(e.key === "Escape") {
            ignore = true;
            draw.finishDrawing();
            ignore = false;
            return false;
          }
        },
        false
      );
      self.addEvent(
        document,
        "mousedown",
        e => {
          e = e || window.event;

          if(!draw.getActive()) {
            return;
          }
          if(e.ctrlKey) {
            draw.removeLastPoint();
            return false;
          }
        },
        false
      );

      draw.on("drawstart", evt =>
        self.drawstart(evt.feature, evt.feature.getGeometry().getCoordinates())
      );
      draw.on("drawend", evt => {
        if(!ignore) {
          self.drawend(evt.feature, evt.feature.getGeometry().getCoordinates());
          modify.setActive(true);
          draw.setActive(false);
        }
      });

      self.map.addInteraction(draw);
      self.map.addInteraction(modify);

      return {
        finishModify() {
          modify.setActive(false);
        },
        finishDrawing() {
          draw.finishDrawing();
        },
        abortDrawing() {
          ignore = true;
          draw.finishDrawing();
          modify.setActive(false);
          ignore = false;
        },
        setActive(value) {
          draw.setActive(value);
          modify.setActive(false);
        },
        getActive() {
          return draw.getActive();
        },
        delete() {
          self.map.removeInteraction(draw);
          self.map.removeInteraction(modify);
        }
      };
    },
    drawstart(feature, coords) {},
    drawend(feature, coords) {
      const self = this;

      feature.setProperties(self.getBaseProps(), true);
      feature.setId(self.nextID--);
      self.modificationLayer.getSource().addFeature(feature);

      self.session.draw = self.$root.createProxy(feature);

      self.$root.$emit(
        "editAttributesElements",
        [feature],
        self.currentLayer.instance.get("fields"),
        self.currentLayer.instance.get("full_type"),
        "draw-single"
      );
    },

    createModyfiInteraction(layer) {
      const self = this;

      const source = layer.getSource();

      const modify = new Modify({
        source,
        pixelTolerance: this.snapTolerance,
        deleteCondition(event) {
          return (
            (event.type === "click" || event.type === "pointerdown") &&
            self.currentEditButton === "remove_node"
          );
        },
        insertVertexCondition(event) {
          return (
            (event.type === "click" || event.type === "pointerdown") &&
            self.currentEditButton === "add_node"
          );
        }
      });
      modify.setActive(false);

      modify.on("modifystart", evt =>
        self.modifystart(evt.features.getArray())
      );
      modify.on("modifyend", evt => self.modifyend(evt.features.getArray()));

      self.map.addInteraction(modify);
      return {
        removeLastSelectPoint() {
          modify.finishDrawing();
        },
        setActive(value) {
          modify.setActive(value);
        },
        getActive() {
          return modify.getActive();
        },
        delete() {
          self.map.removeInteraction(modify);
        }
      };
    },
    modifystart(features) {},
    modifyend(features) {
      const self = this;

      const feature = _.filter(features, f => !f.get("__hide"))[0];
      const geometry = feature.orginalGeometry;

      const oldCoordinates = _(features)
        .filter(f => f.get("__hide"))
        .sortBy([f => f.get("index")])
        .map(f => ({
          coord: self.getPointCoordinate(f.getGeometry()),
          index: f.get("index")
        }))
        .value();

      const coordinates = _.map(
        self.getCoordinates(feature),
        (coord, index) => ({
          coord: self.getPointCoordinate(coord),
          index
        })
      );

      function equals(coordinate1, coordinate2) {
        return coordinate1.coord.equals2D(
          coordinate2.coord,
          equalsCoordinateTolerance
        );
      }
      function find(coordinates1, coordinates2) {
        const results = [];
        _.each(coordinates1, coordinate1 => {
          const el = _.find(coordinates2, coordinate2 =>
            equals(coordinate1, coordinate2)
          );
          if(!el) {
            results.push(coordinate1);
          }
        });
        return results;
      }

      const vertexAdded = [];
      const vertexDeleted = [];
      switch(self.toModeDraw(self.geometry_type)) {
        case "LineString":
        case "Polygon":
          if(coordinates.length < oldCoordinates.length) {
            vertexDeleted.push(...find(oldCoordinates, coordinates));
          } else if(coordinates.length > oldCoordinates.length) {
            vertexAdded.push(...find(coordinates, oldCoordinates));
          }
          break;
      }

      const exist = "modificated" in self.session;
      if(exist) {
        feature.setProperties(self.session.modificated.properties, true);
        self.session.modificated = {
          geometry,
          properties: self.session.modificated.properties,
          feature: self.$root.createProxy(feature),
          vertexAdded,
          vertexDeleted
        };
      } else {
        const properties = _.clone(feature.getProperties());
        delete properties.geometry;
        self.session.modificated = {
          geometry,
          properties,
          feature: self.$root.createProxy(feature),
          vertexAdded,
          vertexDeleted
        };
      }

      /*if(!exist) {
        //auto 
        self.$root.$emit(
          "editAttributesElements",
          [feature],
          self.currentLayer.instance.get("fields"),
          self.currentLayer.instance.get("full_type"),
          "edit-single"
        );
      }*/
    },

    dialogDeleteAction(features) {
      const self = this;
      let msg = features.length > 1 ? `elementów?` : `element?`;

      self.$modal.show("dialog", {
        title: "Usuwanie elementu",
        text: `Czy chcesz usunąć ${features.length} ${msg}`,
        buttons: [
          {
            title: "NIE",
            handler: () => {
              self.$root.$emit("clearSelectionFeatures");
              self.$modal.hide("dialog");
            }
          },
          {
            title: "TAK",
            default: true,
            handler: () => {
              self.selectedLayer.getSource().clear(true);

              _.each(features, feature => {
                self.currentLayer.instance
                  .getSource()
                  .removeFeature(feature.__value);
              });

              self.session.deleted = features;
              self.$modal.hide("dialog");

              self._computedWatchers.deleteEnable.update();
              self._computedWatchers.editionAnyAction.update();
              self.$forceUpdate();
            }
          }
        ]
      });
    },

    createSplitInteraction(features) {
      const self = this;

      const split = new Split({
        features
      });
      split.setActive(false);

      split.on("beforesplit", e => self.beforeSplit(e.original, e.features));
      split.on("aftersplit", e => self.afterSplit(e.original, e.features));

      self.map.addInteraction(split);
      return {
        setActive(value) {
          split.setActive(value);
        },
        getActive() {
          return split.getActive();
        },
        delete() {
          self.map.removeInteraction(split);
        }
      };
    },
    beforeSplit(original, features) {},
    afterSplit(original, features) {
      const self = this;

      const coords = [];
      _.each(features, feature => {
        feature.setId(self.nextID--);
        self.modificationLayer.getSource().addFeature(feature);

        const geom = feature.getGeometry();
        coords.push([
          new Coordinate(...geom.getFirstCoordinate()),
          new Coordinate(...geom.getLastCoordinate())
        ]);
      });
      self.getSource(self.currentLayer.instance).removeFeature(original);

      let splitCoord;
      let coord = coords[0];
      for(let i = 1; i < coords.length; i++) {
        const tc = coords[i];
        if(
          coord[0].equals2D(tc[0], equalsCoordinateTolerance) ||
          coord[0].equals2D(tc[1], equalsCoordinateTolerance)
        ) {
          splitCoord = [coord[0].x, coord[0].y];
          break;
        } else if(
          coord[1].equals2D(tc[0], equalsCoordinateTolerance) ||
          coord[1].equals2D(tc[1], equalsCoordinateTolerance)
        ) {
          splitCoord = [coord[1].x, coord[1].y];
          break;
        }
      }

      self.session.splitted = {
        original: self.$root.createProxy(original),
        results: _.map(features, v => self.$root.createProxy(v)),
        coord: splitCoord
      };
      self.splitActive = false;
    },

    dialogSplitDistanceAction(original) {
      const self = this;

      const flat_max = original.getGeometry().getLength();
      const geo_max = getLength(original.getGeometry());
      let value = +(geo_max / 2).toFixed(2);

      self.$modal.show("dialog", {
        title: "Podaj dystans!",
        text: `<input 
              style="width: 100%;"
              class="input"
              type="number"
              max="${geo_max}"
              min="0",
              step="0.01"
              value="${value}"></input>`,
        buttons: [
          {
            title: "NIE",
            handler: () => {
              //self.$root.$emit("clearSelectionFeatures");
              self.$modal.hide("dialog");
              self.splitActive = false;
            }
          },
          {
            title: "TAK",
            default: true,
            handler: () => {
              value = +document
                .getElementById("geneticDialog")
                .getElementsByClassName("input")[0].value;
              value = (value * flat_max) / geo_max;

              self.$modal.hide("dialog");

              self.splitDistanceExecut(original, value);
            }
          }
        ]
      });
    },
    splitMiddleExecut(original) {
      const self = this;
      const geom = original.getGeometry();
      const features = [];

      const splitCoord = geom.getFlatMidpoint();
      _.each(geom.splitAt(splitCoord, 1e-10), geom => {
        const f = original.clone();
        f.setGeometry(geom);
        features.push(f);
      });

      if(features.length > 1) {
        _.each(features, feature => {
          feature.setId(self.nextID--);
          self.modificationLayer.getSource().addFeature(feature);
        });
        self.getSource(self.currentLayer.instance).removeFeature(original);

        self.session.splitted = {
          original: self.$root.createProxy(original),
          results: _.map(features, v => self.$root.createProxy(v)),
          coord: splitCoord
        };
      } else {
        self.$root.$emit(
          "showSnackbar",
          "error",
          "Nie udało sie podzielić w połowie"
        );
      }

      self.splitActive = false;
    },
    splitDistanceExecut(original, distance) {
      const self = this;
      const geom = original.getGeometry();
      const features = [];

      if(distance <= 0) {
        self.$root.$emit(
          "showSnackbar",
          "error",
          "Nie udało sie podzielić, dystans jest wartością ujemną lub 0"
        );
        self.splitActive = false;
        return;
      }

      if(distance >= geom.getLength()) {
        self.$root.$emit(
          "showSnackbar",
          "error",
          "Nie udało sie podzielić, dystans przekracze długość"
        );
        self.splitActive = false;
        return;
      }

      const fraction = distance / geom.getLength();

      const splitCoord = geom.getCoordinateAt(fraction);
      _.each(geom.splitAt(splitCoord, 1e-10), geom => {
        const f = original.clone();
        f.setGeometry(geom);
        features.push(f);
      });

      if(features.length > 1) {
        _.each(features, feature => {
          feature.setId(self.nextID--);
          self.modificationLayer.getSource().addFeature(feature);
        });
        self.getSource(self.currentLayer.instance).removeFeature(original);

        self.session.splitted = {
          original: self.$root.createProxy(original),
          results: _.map(features, v => self.$root.createProxy(v)),
          coord: splitCoord
        };
      } else {
        self.$root.$emit(
          "showSnackbar",
          "error",
          `Nie udało sie podzielić w ${distance}`
        );
      }

      self.splitActive = false;
    },

    joinLine(features) {
      const lm = new LineMerger();

      const geoms = _.map(features, f => ol_parser.read(f.getGeometry()));
      _.each(geoms, geom => {
        this.roundCoords(
          [
            geom.getCoordinateN(0),
            geom.getCoordinateN(geom.getNumPoints() - 1)
          ],
          4
        );
        lm.add(geom);
      });

      let features_buffor = lm.getMergedLineStrings().toArray();
      if(features_buffor.length === 1) {
        return new Feature(ol_parser.write(features_buffor[0]));
      } else {
        return false;
      }
    },
    getClosestFeatures(source, feature, limit) {
      limit = limit || -1;
      const coords = feature.getGeometry().getCoordinates();

      let start = source.getFeaturesInExtent(
        bufferExtent(createOrUpdateFromCoordinate(coords[0]), 0.5)
      );
      let end = source.getFeaturesInExtent(
        bufferExtent(
          createOrUpdateFromCoordinate(coords[coords.length - 1]),
          0.5
        )
      );

      start = _.filter(start, f => f !== feature);
      end = _.filter(end, f => f !== feature);

      start = limit === -1 ? start : start.length <= limit ? start : [];
      end = limit === -1 ? end : end.length <= limit ? end : [];

      return {
        start,
        end,
        all: [...start, ...end]
      };
    },
    joinExecut(original, features) {
      const self = this;
      const feature = self.joinLine(features);

      if(feature) {
        self.session.joined = {};
        self.session.joined.originals = _.map(features, f =>
          self.$root.createProxy(f)
        );
        self.session.joined.result = self.$root.createProxy(feature);
        self.session.joined.base = original;
        self.cloneProps(original, feature);

        self.modificationLayer.getSource().addFeature(feature);
        _.each(features, feature => {
          self.getSource(self.currentLayer.instance).removeFeature(feature);
        });
      } else {
        self.$root.$emit("showSnackbar", "error", "Błąd scalenia");
      }
    },
    configureJoinAction() {
      const self = this;
      const handle = evt => {
        if(!self.joinActive) return;

        const layer = self.currentLayer.instance.__value;
        const source = this.getSource(layer);
        const source2 = self.allowsSelectLayer.getSource();

        const feature = self.map.forEachFeatureAtPixel(
          evt.pixel,
          (feature, layer2) => feature,
          {
            hitTolerance: 15,
            layerFilter: layer2 => layer2 === self.allowsSelectLayer
          }
        );

        if(feature) {
          self.allowsSelectLayer.getSource().removeFeature(feature);
          self.selectedLayer.getSource().addFeature(feature);

          let features = self.getClosestFeatures(source, feature, 1).all;
          features = _.filter(
            features,
            f => !self.selectedLayer.getSource().hasFeature(f)
          );
          self.allowsSelectLayer.getSource().addFeatures(features);

          features = this.selectedLayer.getSource().getFeatures();

          const buttons = [
            {
              title: "NIE",
              handler: () => {
                self.$modal.hide("dialog");
                self.joinActive = false;
                self.$root.$emit("clearSelectionFeatures");
              }
            },
            {
              title: "TAK",
              default: true,
              handler: () => {
                self.selectedLayer.getSource().clear(true);
                self.joinExecut(self.currentFeatures[0], features);

                self.joinActive = false;
                self.$modal.hide("dialog");
              }
            }
          ];

          if(!self.allowsSelectLayer.getSource().isEmpty()) {
            buttons.push({
              title: "ZAZNACZ NASTĘPNY",
              default: false,
              handler: () => {
                self.$modal.hide("dialog");
              }
            });
          }

          self.$modal.show("dialog", {
            title: "Złączanie elementów",
            text: `Czy chcesz złączyć ${features.length} elementów?`,
            buttons
          });
        }
      };
      self.map.on("click", handle);
      return {
        delete() {
          self.map.un("click", handle);
        }
      };
    },

    createSnapInteraction() {
      if(this.snapTolerance > 0) {
        this.snapInteraction = new Snap({
          features: this.snapFeatures,
          pixelTolerance: this.snapTolerance
        });
        this.map.addInteraction(this.snapInteraction);
      } else {
        this.snapInteraction = false;
      }
    },
    //</editor-fold>

    zapiszNaSerwerze(opt_options) {
      const self = this;

      const options = opt_options || {};

      if(options.type === "attributes") {
        if(options.ids) {
          //masowa edycja atrybutów
          const data = {
            layer: options.layer || self.currentLayer.save_key,
            ids: options.ids,
            properties: options.properties
          };

          return self.socketEmit("put/features/attributes", data);
        } else {
          //edycja atrybutów modyfikowanej lub nowo dodanej geometrii
          if("draw" in self.session) {
            //nowo narysowane
            const feature = self.session.draw.__value;

            feature.setProperties(options.properties, true);
          } else if("modificated" in self.session) {
            //nowo zmodyfikowane
            const modificated = self.session.modificated;
            const feature = modificated.feature.__value;

            feature.setProperties(options.properties, true);
          }

          return Promise.resolve();
        }
      } else if(options.type === "add") {
        //nowy element bez geometrii

        const data = {
          layer: options.layer || self.currentLayer.save_key,
          //table : self.currentLayer.name,
          geometry: "none",
          properties: options.properties,
          intersection_points: []
        };

        return self.socketEmit("post/features", data);
      }

      if("draw" in self.session) {
        //nowo narysowane
        const feature = self.session.draw.__value;

        const properties = _.extend(
          {},
          feature.getProperties(),
          options.type === "attributes" ? options.properties : {}
        );
        delete properties.geometry;

        let intersection_points = [];
        if("LineString" === feature.getGeometry().getType()) {
          intersection_points = _.map(
            self.getIntersectionPoints(
              feature,
              self.currentLayer.instance.__value
            ),
            geom => ({
              geometry: formatGeoJSON.writeGeometryObject(geom),
              properties: {}
            })
          );
        }

        const data = {
          layer: self.currentLayer.save_key,
          //table : self.currentLayer.name,
          geometry: formatGeoJSON.writeGeometryObject(feature.getGeometry()),
          properties,
          intersection_points
        };

        return self.socketEmit("post/features", data);
      } else if("deleted" in self.session) {
        //usunięte
        const features = _.map(self.session.deleted, proxy =>
          proxy.__value.getId()
        );
        let layer_name = self.currentLayer.save_key;
        const data = {
            layer: layer_name
        };
        data[layer_name] = features;

        return self.socketEmit("delete/features", data);
      } else if("modificated" in self.session) {
        //nowo zmodyfikowane
        const modificated = self.session.modificated;
        const feature = modificated.feature.__value;

        const properties = _.extend(
          {},
          feature.getProperties(),
          options.type === "attributes" ? options.properties : {}
        );
        delete properties.geometry;

        const data = {
          id: feature.getId(),
          //featureId : feature.getId(),
          properties,
          layer: self.currentLayer.save_key,
          //table : self.currentLayer.name,
          geometry: formatGeoJSON.writeGeometryObject(feature.getGeometry()),
          created: _.map(modificated.vertexAdded, coord => coord.index),
          deleted: _.map(modificated.vertexDeleted, coord => coord.index)
        };
        return self.socketEmit("put/features", data);
      } else if("joined" in self.session) {
        //nowo złaczone
        const featuresJoined = _.map(self.session.joined.originals, proxy =>
          proxy.__value.getId()
        );
        const feature = self.session.joined.base.__value.getId();

        const data = {
          layer: self.currentLayer.save_key,
          //table : self.currentLayer.name,
          features: [
            feature,
            ..._.filter(featuresJoined, id => id !== feature)
          ],
          featureId: feature
        };
        return self.socketEmit("put/features/merge", data);
      } else if("splitted" in self.session) {
        //nowo podzielone
        const splitted = self.session.splitted;
        const feature = splitted.original.__value.getId();
        const data = {
          split: [feature],
          properties: {},
          //featureId : feature,
          layer: self.currentLayer.save_key,
          //table : self.currentLayer.name,
          geometry: formatGeoJSON.writeGeometryObject(new Point(splitted.coord))
        };
        return self.socketEmit("put/features", data);
      }

      return Promise.resolve(true);
    },
    splaszczGeometrie(feature) {
      let geom = feature.getGeometry();
      if(geom) {
        if(geom.getType() === "MultiPoint") {
          geom = geom.getPoint(0);
        } else if(geom.getType() === "MultiLineString") {
          geom = geom.getLineString(0);
        } else if(geom.getType() === "MultiPolygon") {
          geom = geom.getPolygon(0);
        }
        feature.setGeometry(geom);
      }
      return feature;
    },
    odswiezWidok(list) {
      const self = this;
      /*
        {
          inserted – lista dodanych obiektów geojeson,
          updated – lista zmienionych obiektów geojeson,
          deleted – lista usuniętych obiektów geojeson,            
        }
                                      
        */

      const layers = _(self.layersList)
        .filter(layer => 'save_key' in layer)
        .groupBy("save_key")
        .mapValues((v) => (v.length === 1 ? v[0] : _.keyBy(v, "save_key_suffix")))
        .value();

      function getSource(layerDef, split_key) {
        if(!('instance' in layerDef)) {
          layerDef = layerDef[`${split_key}`];
        }
        if(!('instance' in layerDef)) {
          return false;
        }
        
        return self.getSource(layerDef.instance);
      }

      _.each(list, (data, key) => {
        const layerDef = layers[key];

        _.each(data.inserted || [], feature => {
          const source = getSource(layerDef, feature.properties.net_type);
          if(!source) {
            console.log('odswiezWidok, błedny klucz - inserted', layerDef, feature);
            return;
          }

          feature = formatGeoJSON.readFeatureFromObject(feature, {
            dataProjection: self.srid,
            featureProjection: self.$root.projection
          });
          feature = self.splaszczGeometrie(feature);

          source.addFeature(feature);
          self.snapFeatures.push(feature);
        });

        _.each(data.deleted || [], feature => {
          const source = getSource(layerDef, feature.net_type);
          if(!source) {
            console.log('odswiezWidok, błedny klucz - deleted', layerDef, feature);
            return;
          }

          feature = source.getFeatureById(feature.id);
          if(feature) {
            source.removeFeature(feature);
            self.snapFeatures.remove(feature);
          } else {
            //jeżeli warstwa ma jeszcze niezaczytane dane
          }
        });

        _.each(data.updated || [], feature => {
          const source = getSource(layerDef, feature.properties.net_type);
          if(!source) {
            console.log('odswiezWidok, błedny klucz - updated', layerDef, feature);
            return;
          }

          feature = formatGeoJSON.readFeatureFromObject(feature, {
            dataProjection: self.srid,
            featureProjection: self.$root.projection
          });
          feature = self.splaszczGeometrie(feature);

          const f_old = source.getFeatureById(feature.getId());
          if(f_old) {
            source.removeFeature(f_old);
            self.snapFeatures.remove(f_old);
            source.addFeature(feature);
            self.snapFeatures.push(feature);
          } else {
            //jeżeli warstwa ma jeszcze niezaczytane dane   
          }
        });
      });

      this.$root.$emit("refreshAttributeTableData");
    },

    //<editor-fold defaultstate="collapsed" desc="akcje">
    przelaczenieWTrybEdycji() {
      const self = this;

      if(self.edition) {
        function restoreLast(mode, feature) {
          switch(mode) {
            case "modyfi": {
              if(feature) {
                self.$store.commit("setCurrentSelectedFeatures", [
                  self.$root.createProxy(feature)
                ]);
                self.selectedLayer.getSource().addFeature(feature);
              }
              break;
            }
            case "draw": {
              break;
            }
            case "join": {
              if(feature) {
                self.$store.commit("setCurrentSelectedFeatures", [
                  self.$root.createProxy(feature)
                ]);
                self.selectedLayer.getSource().addFeature(feature);
              }
              break;
            }
            case "split": {
              if(feature) {
                self.$store.commit("setCurrentSelectedFeatures", [
                  self.$root.createProxy(feature)
                ]);
                self.selectedLayer.getSource().addFeature(feature);
              }
              break;
            }
          }
        }
        function execut() {
          self.edition = !self.edition;

          if(!self.editionAnyAction) {
            //jaka narzędzie jest wyłączone
            self.offSelectionTools();
            self.discardChanges();

            restoreLast(self.lastMode.mode, self.lastMode.feature);
          } else {
            //najpierw wyłaczyć narzedzie a następnie cofnąć
            self.$once("changeModeEnd", (mode, state, feature) => {
              self.offSelectionTools();
              self.discardChanges();

              restoreLast(mode, feature);
            });

            self.disabledModes();
          }
        }

        if(!self.isSessionEmpty()) {
          self.$modal.show("dialog", {
            title: "Niezapisane zmiany!",
            text: `Masz niezapisane zmiany, czy napewno chcesz rozłączyć się?`,
            buttons: [
              {
                title: "NIE",
                default: true,
                handler: () => {
                  self.$modal.hide("dialog");
                }
              },
              {
                title: "TAK",
                handler: () => {
                  execut();
                  self.$modal.hide("dialog");
                }
              }
            ]
          });
        } else {
          self.edition = !self.edition;
        }
      } else {
        self.edition = !self.edition;
      }
    },

    akcjaWstawObiekt() {
      this.drawActive = !this.drawActive;
    },
    akcjaZapisz() {
      const self = this;

      function restoreLast(mode, feature) {
        switch(mode) {
          case "modyfi": {
            if(feature) {
              self.$store.commit("setCurrentSelectedFeatures", [
                self.$root.createProxy(feature)
              ]);
              self.selectedLayer.getSource().addFeature(feature);
            }
            break;
          }
          case "draw": {
            break;
          }
          case "join":
          case "split": {
            return;
            break;
          }
        }
        self.$nextTick(() => {
          self.$set(self, `${mode}Active`, true);
        });
      }

      if(!self.editionAnyAction) {
        //jaka narzędzie jest wyłączone
        self.offSelectionTools();
        self
          .zapiszNaSerwerze()
          .then(() => {
            self.discardChanges();
            self.$root.$once("refreshAttributeTableData", () => {
              restoreLast(
                self.lastMode.mode,
                self.lastMode.feature &&
                self.findFeature(self.lastMode.feature.getId())
              );
            });

            self.$root.$emit("showSnackbar", "success", "Zapisano");
          })
          .catch(error => {
            self.$root.$emit("showSnackbar", "error", "Błąd zapisu");
          });
      } else {
        /*
         * najpierw wyłaczyć narzedzie a następnie zapisać
         */
        self.$once("changeModeEnd", (mode, state, feature) => {
          self.offSelectionTools();
          self
            .zapiszNaSerwerze()
            .then(() => {
              self.discardChanges();
              self.$root.$once("refreshAttributeTableData", () => {
                restoreLast(mode, feature && self.findFeature(feature.getId()));
              });

              self.$root.$emit("showSnackbar", "success", "Zapisano");
            })
            .catch(error => {
              self.$root.$emit("showSnackbar", "error", "Błąd zapisu");
            });
        });

        self.disabledModes();
      }
    },
    akcjaEdytujGeometrie() {
      this.modyfiActive = !this.modyfiActive;
    },
    akcjaZlacz() {
      this.joinActive = !this.joinActive;
    },
    akcjaRozdziel() {
      this.splitActive = !this.splitActive;
    },
    akcjaCofnij() {
      const self = this;

      function restoreLast(mode, feature) {
        switch(mode) {
          case "modyfi": {
            if(feature) {
              self.$store.commit("setCurrentSelectedFeatures", [
                self.$root.createProxy(feature)
              ]);
              self.selectedLayer.getSource().addFeature(feature);
            }
            break;
          }
          case "draw": {
            break;
          }
          case "join": {
            if(feature) {
              self.$store.commit("setCurrentSelectedFeatures", [
                self.$root.createProxy(feature)
              ]);
              self.selectedLayer.getSource().addFeature(feature);
            }
            break;
          }
          case "split": {
            if(feature) {
              self.$store.commit("setCurrentSelectedFeatures", [
                self.$root.createProxy(feature)
              ]);
              self.selectedLayer.getSource().addFeature(feature);
            }
            break;
          }
        }

        self.$nextTick(() => {
          if(`${mode}Active` === "splitActive") {
            switch(self.currentSplitButton) {
              case "split_middle":
              case "split_distance": {
                //nie załączaj nażędzia w tych trybach
                return;
              }
            }
          } else if(`${mode}Active` === "modyfiActive") {
            if(self.currentFeatures.length === 0) {
              return;
            }
          }
          self.$set(self, `${mode}Active`, true);
        });
      }

      if(!self.editionAnyAction) {
        //jaka narzędzie jest wyłączone
        self.offSelectionTools();
        self.discardChanges();

        restoreLast(self.lastMode.mode, self.lastMode.feature);
      } else {
        //najpierw wyłaczyć narzedzie a następnie cofnąć
        self.$once("changeModeEnd", (mode, state, feature) => {
          self.offSelectionTools();
          self.discardChanges();

          restoreLast(mode, feature);
        });

        self.disabledModes();
      }
    },
    akcjaUsun() {
      this.offSelectionTools();
      this.dialogDeleteAction(this.currentFeatures);
    },
    akcjaOtworzUstawienia() {
      this.show("SettingsSnap");
    },

    akcjaOtworzTabeleDanych() {
      this.tableDataActive = !this.tableDataActive;
      if(this.tableDataActive) {
        this.$root.$emit("showSnackbar", "blue", "Ładowanie danych proszę czekać");
        setTimeout(() => {
          this.$root.$emit("openAttributeTableData", this.currentLayer.instance.__value);
        }, 500);
      } else {
        this.$root.$emit("closeAttributeTableData");
      }
    },
    akcjaOtworzOknoImportu() {
      this.show("dataImportModal");
    },
    closedAttributeTableData() {
      if(this.tableDataActive) {
        this.akcjaOtworzTabeleDanych();
      }
    },

    akcjaOtworzAtrybuty() {
      this.$root.$emit(
        "editAttributesElements",
        _.map(this.currentFeatures, f => f.__value),
        this.currentLayer.instance.get("fields"),
        this.currentLayer.instance.get("full_type"),
        "edit-attr"
      );
    },

    akcjaEksportuj() {
      const features = this.getSource(this.currentLayer.instance)
        .getFeatures();
      const geojson = formatGeoJSON.writeFeaturesObject(features, {
        dataProjection: this.srid,
        featureProjection: this.$root.projection
      });
      ShpGenerate(geojson, {
        folder: this.currentLayer.name || 'aquagis',
        srid: this.srid
      });
    },

    dodajDoEdycji(feature) {
      this.currentFeatures.push(feature);
    },

    akcjaKopiujFeatures() {
      this.copyFields = this.currentLayer.fields;
      const writer = new GeoJSON();
      this.copyFeatures = _.map(this.currentFeatures, f => writer.writeFeatureObject(f.__value));
      this.copyGeometryType = this.geometry_type;
      this.$root.$emit("showSnackbar", "success", `Skopiowano ${this.copyFeatures.length} elementów`);
    },
    akcjaWklejFeatures() {
      if(this.copyGeometryType !== this.geometry_type) {
        this.$root.$emit("showSnackbar", "red", `Różne typy geometrii <br/> nie mozna wkleić`);
        return;
      }

      const layer = this.currentLayer.instance.__value;
      const source = this.getSource(layer);
      this.$root.$once("saveCopyPastFeatures", (features) => {
        if(!features) {
          return;
        }
        const reader = new GeoJSON();//readFeature
        const featuresOL = _.map(features, f => reader.readFeature(_.clone(f)));

        if(this.currentLayer.type === "user") {
          source.addFeatures(featuresOL);
          this.userLayersSession.added.extend(featuresOL);
        } else if(this.currentLayer.type === "temp") {
          source.addFeatures(featuresOL);
        }

        this.$root.$emit("showSnackbar", "success", `Dodano ${features.length} obiektów`);
        this.userLayerState = "copy";

        //console.log('akcjaWklejFeatures', _.clone(features), featuresOL);
      });

      this.show("CopyPastFeatures");
      this.$root.$emit("openCopyPastFeatures", this.copyFields, this.currentLayer.fields, this.copyFeatures);
    },
    //</editor-fold>

    //<editor-fold defaultstate="collapsed" desc="user layers">
    changeEditModeUserLayer(mode, submode) {
      const self = this;
      const layer = self.currentLayer.instance.__value;

      if(self.ul_last_interaction) {
        self.ul_last_interaction.end();
        self.ul_last_interaction = undefined;
      }

      const lastMode = self.userLayerState;
      self.userLayerState = `${mode}${submode ? `_${submode}` : ""}`;
      if(lastMode === self.userLayerState) {
        self.userLayerState = "ignore";
        return;
      }
      switch(mode) {
        case "add":
          self.ul_last_interaction = self.addULInteraction(layer, submode, {
            end(feature, geometry) {
              feature.setProperties(self.getBaseProps(), true);
              self.userLayersSession.added.push(feature);
            }
          });
          break;
        case "edit":
          self.ul_last_interaction = self.editULInteraction(layer, {
            end(features) {
              _.each(features, feature => {
                try {
                  self.userLayersSession.modyfi.push(feature);
                } catch(e) {}
              });
            }
          });
          break;
        case "delete":
          self.ul_last_interaction = self.deleteULInteraction(layer, {
            end(features) {
              self.userLayersSession.deleted.extend(features);
            }
          });
          break;
        case "save":
          self.saveULCollections(layer);
          break;
        case "cancel":
          self.clearULCollections(layer, true);
          self.userLayerState = false;
          break;
      }
    },
    editULInteraction(layer, actions = {}) {
      const self = this;

      const source = this.getSource(layer);

      const modify = new Modify({
        source,
        pixelTolerance: this.snapTolerance
      });

      modify.on("modifystart", evt => {
        _(evt.features.getArray())
          .filter(feature => !("_org_geometry" in feature))
          .each(feature => {
            feature._org_geometry = formatWKT.writeGeometryText(
              feature.getGeometry()
            );
          })
          .value();
        "start" in actions && actions.start(evt.features.getArray());
      });
      modify.on("modifyend", evt => {
        const features = _.filter(
          evt.features.getArray(),
          feature =>
            "_org_geometry" in feature &&
            formatWKT.writeGeometryText(feature.getGeometry()) !==
            feature._org_geometry
        );
        "end" in actions && actions.end(features);
      });

      self.map.addInteraction(modify);
      return {
        end() {
          self.map.removeInteraction(modify);
        }
      };
    },
    addULInteraction(layer, geometry_type, actions = {}) {
      const self = this;

      const source = this.getSource(layer);

      const draw = new Draw({
        source: source,
        type: geometry_type,
        snapTolerance: this.snapTolerance
      });

      draw.on(
        "drawstart",
        evt =>
          "start" in actions &&
          actions.start(evt.feature, evt.feature.getGeometry())
      );
      draw.on(
        "drawend",
        evt =>
          "end" in actions &&
          actions.end(evt.feature, evt.feature.getGeometry())
      );

      self.map.addInteraction(draw);

      return {
        end() {
          self.map.removeInteraction(draw);
        }
      };
    },
    deleteULInteraction(layer, actions = {}) {
      const self = this;

      const source = this.getSource(layer);

      function dialog(features) {
        let msg = features.length > 1 ? `elementów?` : `element?`;
        "start" in actions && actions.start(features);

        self.$modal.show("dialog", {
          title: "Usuwanie elementu",
          text: `Czy chcesz usunąć ${features.length} ${msg}`,
          buttons: [
            {
              title: "NIE",
              handler: () => {
                self.$modal.hide("dialog");
              }
            },
            {
              title: "TAK",
              default: true,
              handler: () => {
                _.each(features, feature => source.removeFeature(feature));

                "end" in actions && actions.end(features);
                self.$modal.hide("dialog");
              }
            }
          ]
        });
      }

      function execute(evt) {
        const feature = self.map.forEachFeatureAtPixel(
          evt.pixel,
          (feature, layer) => feature,
          {
            hitTolerance: 15,
            layerFilter: l => l.get("id") === layer.get("id")
          }
        );

        if(feature) {
          dialog([feature]);
        }
      }

      self.map.on("click", execute);
      return {
        end() {
          self.map.un("click", execute);
        }
      };
    },
    clearULCollections(layer, cancel = false) {
      const self = this;

      const source = this.getSource(layer);

      if(cancel) {
        source.addFeatures(self.userLayersSession.deleted.getArray());
        _.each(self.userLayersSession.added.getArray(), feature =>
          source.removeFeature(feature)
        );
        _.each(self.userLayersSession.modyfi.getArray(), feature => {
          feature.setGeometry(
            formatWKT.readGeometryFromText(feature._org_geometry)
          );
        });
      }

      self.userLayersSession.added.clear();
      self.userLayersSession.modyfi.clear();
      self.userLayersSession.deleted.clear();
    },
    saveULCollections(layer) {
      const self = this;

      if(self.userLayersSession.added.getArray().length === 0
        && self.userLayersSession.deleted.getArray().length === 0
        && self.userLayersSession.modyfi.getArray().length === 0) {
        this.$root.$emit("showSnackbar", "orange", `Nie ma nic do zapisania`);
        return;
      }

      const srid = layer.get("srid");
      const table = layer.get("table");
      const fields = layer.get("fields");

      const added = self.userLayersSession.added.getArray().slice();

      const payload = {
        data: {
          delete: _.map(self.userLayersSession.deleted.getArray(), feature =>
            feature.getId()
          ),
          post: formatGeoJSON.writeFeaturesObject(added, {
            dataProjection: `EPSG:${srid}`,
            featureProjection: self.$root.projection
          }).features,
          put: formatGeoJSON.writeFeaturesObject(
            self.userLayersSession.modyfi.getArray(),
            {
              dataProjection: `EPSG:${srid}`,
              featureProjection: self.$root.projection
            }
          ).features
        },
        table
      };

      fetch(
        `${this.$store.getters.getApiURL}/users_layers/update?token=${
        this.$store.getters.getToken
        }`,
        {
          method: "post",
          body: JSON.stringify(payload)
        }
      )
        .then(res => res.json())
        .then(data => {
          _.each(data.inserted, (id, i) => {
            added[i].setId(id);
          });

          self.clearULCollections(layer, false);
          self.userLayerState = false;
          self.$root.$emit("showSnackbar", "success", data.message);
        })
        .catch(error => {
          console.log("Błąd: ", error);

          self.clearULCollections(layer, true);
          self.userLayerState = false;
          self.$root.$emit("showSnackbar", "red", error);
        });

      //self.clearULCollections(layer, true); //zamienić na bez cofania
    },

    removeUserLayer(currentLayer) {
      const self = this;
      const layer = currentLayer.instance.__value;
      
      self.$emit("confDialogOpened", true);
      self.$modal.show("dialog", {
        title: "Usuwanie warstwy użytkownika",
        text: "Czy na pewno chcesz usunąć warstwę użytkownika?",
        buttons: [
          {
            title: "NIE",
            handler: () => {
              self.$emit("confDialogOpened", false);
              self.$modal.hide("dialog");
              return;
            }
          },
          {
            title: "TAK",
            default: true,
            handler: () => {
              self.$root.$once("deletedLayer", (type, key, value) => {
                if (type === "user" && layer.get("full_type") === key) {
                  if (value) {
                    self.currentLayer = undefined;
                    self.updateLayers();
                  }
                  
                  self.$emit("confDialogOpened", false);
                  self.$modal.hide("dialog");
                }
              });
              self.$root.$emit("deleteLayer", "user", layer);             
            }
          }
        ]
      });
    },
    createNewUserLayer() {
      _;
      this.show("NewUserLayer");
    },
    //</editor-fold>

    //<editor-fold defaultstate="collapsed" desc="temp layers">
    changeEditModeTempLayer(mode, submode) {
      const self = this;
      const layer = self.currentLayer.instance.__value;

      if(self.tl_last_interaction) {
        self.tl_last_interaction.end();
        self.tl_last_interaction = undefined;
      }

      const lastMode = self.tempLayerState;
      self.tempLayerState = `${mode}${submode ? `_${submode}` : ""}`;
      if(lastMode === self.tempLayerState) {
        self.tempLayerState = false;
        return;
      }
      switch(mode) {
        case "add":
          self.tl_last_interaction = self.addULInteraction(layer, submode, {
            end(feature, geometry) {
              feature.setProperties(self.getBaseProps(), true);
            }
          });
          break;
        case "edit":
          self.tl_last_interaction = self.editULInteraction(layer, {
            end(features) {

            }
          });
          break;
        case "delete":
          self.tl_last_interaction = self.deleteULInteraction(layer, {
            end(features) {

            }
          });
          break;
      }
    },
    removeTempLayer(currentLayer) {
      const self = this;
      self.$modal.show("dialog", {
        title: "Usuwanie warstwy tymczasową",
        text: "Czy na pewno chcesz usunąć warstwę tymczasową?",
        buttons: [
          {
            title: "NIE",
            handler: () => {
              self.$modal.hide("dialog");
              return;
            }
          },
          {
            title: "TAK",
            default: true,
            handler: () => {
              self.$root.$emit(
                "deleteLayer",
                "user",
                currentLayer.instance.__value
              );
              self.$root.$emit(
                "showSnackbar",
                "success",
                "Pomyślnie usunięto warstwę użytkownika"
              );
              self.currentLayer = undefined;
              self.updateLayers();
            }
          }
        ]
      });
    },
    //</editor-fold>

    changeModeEnd(mode, state, feature) {
      this.lastMode = {
        mode,
        state,
        feature
      };
    },
    disabledModes() {
      this.modyfiActive = false;
      this.drawActive = false;
      this.joinActive = false;
      this.splitActive = false;
    },
    findFeature(id) {
      if(this.currentLayer) {
        const layer = this.currentLayer.instance.__value;
        return this.getSource(layer).getFeatureById(id);
      } else {
        return null;
      }
    },

    offListeners() {
      const self = this;
      self.$root.$emit("closeAttributeTableData");
      self.$store.commit("setCurrentEditedLayer", undefined);
      _.each(self.interactions.draw, draw => {
        draw.delete();
      });
      self.interactions.modyfi.delete();
      self.interactions.split.delete();
      if(self.snapInteraction) {
        self.map.removeInteraction(self.snapInteraction);
      }
      self.interactions.join.delete();

      if(self.currentLayer && self.currentLayer.type === "user") {
        self.changeEditModeUserLayer("cancel");
      } else if(self.currentLayer && self.currentLayer.type === "temp") {
        if(self.tl_last_interaction) {
          self.tl_last_interaction.end();
          self.tl_last_interaction = undefined;
        }
      }

      self.$root.$off("deleteSelectedFeatures", self.dialogDeleteAction);
      self.$root.$off("saveServerFeatures", self.zapiszNaSerwerze);
      self.$off("changeModeEnd", self.changeModeEnd);
      self.$root.$off("closedAttributeTableData", self.closedAttributeTableData);

      self.discardChanges();
      if(self.socket) self.socket.disconnect();
      self.edition = false;
    },
    /*calcWidthRibbon: _.debounce(function () {
      this.$root.$emit('calcWidthRibbon');
    }, 1000)*/
  },
  created() {
    formatGeoJSON = new GeoJSON({
      dataProjection: this.srid,
      featureProjection: this.$root.projection
    });

    this.interactions = {};

    this.currentToken = this.$store.getters.getToken;
    this.currentApiURL = this.$store.getters.getApiURL;
    this.joinFeatures = [];
    this.allowsJoinFeatures = new Set();

    this.interactions.join = this.configureJoinAction();

    this.splitFeatures = new Collection();
    this.interactions.split = this.createSplitInteraction(this.splitFeatures);

    this.interactions.draw = {};
    _.each(["Point", "LineString", "Polygon"], geometry_type => {
      this.interactions.draw[geometry_type] = this.createDrawInteraction(
        geometry_type
      );
    });

    this.interactions.modyfi = this.createModyfiInteraction(
      this.modificationLayer
    );

    this.$root.$on("deleteSelectedFeatures", this.dialogDeleteAction);
    this.$root.$on("saveServerFeatures", this.zapiszNaSerwerze);
    this.$root.$on("closedAttributeTableData", this.closedAttributeTableData);

    //userLayers
    this.userLayersSession = {
      added: new Collection(),
      modyfi: new Collection(),
      deleted: new Collection()
    };

    //musi być na końcu
    this.snapFeatures = new Collection();
    this.createSnapInteraction();

    this.lastMode = {};
    this.$on("changeModeEnd", this.changeModeEnd);

    //console.log(this);
  },
  mounted() {
    if(!this.$store.getters.getLoadToMap.user) {
      this.$root.$emit("loadToMap", "user");
    }
    this.$root.$on("updateLayers", this.updateLayers);
    this.$root.$on("addedUserLayer", this.setActiveLayer);
  },
  updated() {
    //this.calcWidthRibbon();
  },
  beforeDestroy() {
    this.offListeners();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/edition/Edition.vue